import { useContext } from 'react'

import { Form } from 'components/Form'
import Loading from 'components/Loading'
import { PrebidModulesContext } from 'features/globalSetup/contexts/PrebidModulesContext'
import { useUpdateWorkspacePrebidModule } from '../../hooks/useUpdateWorkspacePrebidModule'
import { EditSchema, editSchema, editSchemaDefault } from '../../schemas/editSchema'
import { AnalyticsAdaptersForm } from './AnalyticsAdaptersForm'

export const EditContainer = (): React.JSX.Element => {
  const { formId, loading, setTouched, setValid, workspacePrebidModule } =
    useContext(PrebidModulesContext)
  const { errors: apiErrors, update } = useUpdateWorkspacePrebidModule({
    moduleType: 'analytics',
  })

  if (!workspacePrebidModule) {
    return <Loading />
  }

  return (
    <Form<EditSchema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={(data: EditSchema) => update(workspacePrebidModule.id, data)}
      onTouched={setTouched}
      onValid={setValid}
      schema={editSchema}
      schemaDefaults={editSchemaDefault(workspacePrebidModule)}
    >
      {() => <AnalyticsAdaptersForm variant='edit' />}
    </Form>
  )
}
